import { render, staticRenderFns } from "./thirdlogin.vue?vue&type=template&id=2ffb9b82&scoped=true&"
import script from "./thirdlogin.vue?vue&type=script&lang=js&"
export * from "./thirdlogin.vue?vue&type=script&lang=js&"
import style0 from "./thirdlogin.vue?vue&type=style&index=0&id=2ffb9b82&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffb9b82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ffb9b82')) {
      api.createRecord('2ffb9b82', component.options)
    } else {
      api.reload('2ffb9b82', component.options)
    }
    module.hot.accept("./thirdlogin.vue?vue&type=template&id=2ffb9b82&scoped=true&", function () {
      api.rerender('2ffb9b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/login/thirdlogin.vue"
export default component.exports